import React from 'react';
import { bool, shape, string } from 'prop-types';

const DriverColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.47 8.415C16.1775 5.2575 13.32 3 10.17 3C10.0275 3 9.885 3.0075 9.7425 3.015C1.5 3.555 1.5 12.9 1.5 12.9V13.5C1.5 14.325 2.175 15 3 15H10.5C14.0025 15 16.8075 11.9925 16.47 8.415ZM3.945 8.67C4.3725 7.7025 4.905 6.9075 5.55 6.2775L8.265 7.425C8.715 7.6125 9 8.0475 9 8.535C9 9.2025 8.46 9.7425 7.7925 9.7425H3.54C3.6525 9.3975 3.78 9.0375 3.945 8.67ZM13.83 12.03C12.975 12.9675 11.76 13.5 10.5 13.5H3V12.9C3 12.885 3.0075 12.21 3.18 11.25H7.7925C9.285 11.25 10.5 10.035 10.5 8.5425C10.5 7.455 9.8475 6.4725 8.85 6.0525L6.975 5.2575C7.8 4.83 8.7525 4.5825 9.84 4.515C9.9525 4.5 10.065 4.5 10.17 4.5C12.6525 4.5 14.7675 6.2775 14.9775 8.5575C15.0975 9.8475 14.6925 11.0775 13.83 12.03Z" fill="currentColor" />
  </svg>
);

DriverColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default DriverColor;
